import { attach, sample } from 'effector'

import { portalAPI } from '@/shared/api'
import { analytics } from '@/shared/lib/analytics'

const sendPageHitFx = attach({ effect: portalAPI.pageHit })

sample({
    clock: analytics.pagehit,
    target: sendPageHitFx,
})
